import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback } from 'react';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

import { usePrefillCarInfo } from './usePrefillCarInfo';

export const useUpdateCarNumberField = (carNumberFieldName: keyof Pick<TPledgeAutoFields, 'carNumber'>) => {
  const { reset, getValues, getFieldState } = useFormContext<TPledgeAutoFields>();
  const isCarNumberDirty = getFieldState(carNumberFieldName).isDirty;

  const onUpdateCarInfoData = (mappedData: TPledgeAutoFields) => {
    reset({ ...mappedData, isTaxi: mappedData.isTaxi || getValues('isTaxi') });
  };

  const { prefillFieldsByCarNumber } = usePrefillCarInfo(carNumberFieldName, onUpdateCarInfoData);

  const runUpdateCarNumberOnBlur = useCallback(() => {
    prefillFieldsByCarNumber();
  }, [prefillFieldsByCarNumber]);

  return {
    runUpdateCarNumberOnBlur,
    isCarNumberDirty,
  };
};
